import { createQuietIdleTask } from '~/utils/quietIdleTask'
import { runWhenIdle } from '#layers/base/utils/idle'

const SIZEKICK_INTERACTION_QUIET_MS = 2500

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const allowedPages = ['/p/', '/success']
    const interactionEvents = ['keydown', 'pointerdown', 'scroll', 'touchstart']
    let hasScheduledInteractionListeners = false

    const injectScript = () => {
      removeInteractionListeners()

      try {
        if (!document.getElementById('sizekick-script')) {
          const script = document.createElement('script')
          script.id = 'sizekick-script'
          script.src = 'https://widget.sizekick.io/goldner.js'
          script.type = 'module'
          script.async = true
          document.head.appendChild(script)
        }
      } catch (e) {
        console.error('Failed to initialize Sizekick widget', e)
      }
    }

    const deferredInjection = createQuietIdleTask(
      injectScript,
      SIZEKICK_INTERACTION_QUIET_MS,
      runWhenIdle,
    )

    function removeInteractionListeners() {
      if (!hasScheduledInteractionListeners) {
        return
      }

      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, deferScriptInjection)
      })
      hasScheduledInteractionListeners = false
    }

    function deferScriptInjection() {
      // Sizekick is expensive enough to contend with both size selection and
      // an immediate add-to-cart. Wait for a short interaction-quiet window,
      // then let the browser choose an idle period for initialization.
      deferredInjection.schedule()
    }

    const scheduleScriptInjection = () => {
      if (document.getElementById('sizekick-script')) {
        return
      }

      if (hasScheduledInteractionListeners) {
        return
      }

      interactionEvents.forEach((eventName) => {
        window.addEventListener(eventName, deferScriptInjection, {
          passive: eventName !== 'keydown',
        })
      })
      hasScheduledInteractionListeners = true
    }

    const removeScript = () => {
      try {
        removeInteractionListeners()
        deferredInjection.cancel()

        const script = document.getElementById('sizekick-script')
        if (script) {
          script.remove()
        }
      } catch (e) {
        console.error('Failed to remove Sizekick script', e)
      }
    }

    nuxtApp.hook('page:finish', () => {
      const route = useRoute()
      const isAllowedPage = allowedPages.some((path) =>
        route.path.includes(path),
      )
      if (isAllowedPage) {
        scheduleScriptInjection()
      } else {
        removeScript()
      }
    })
  }
})
